<button
  type="button"
  class="menu-help-container"
  #helpPopper="pxTooltip"
  *ngIf="!addin && !hideLaunchButton"
  pxTooltip="Get help"
  pxTooltipPlacement="right"
  pxTooltipClass="px-tooltip-nowrap"
  [pxTooltipDisabled]="helpFormVisible"
  (click)="toggleHelpForm()"
>
  <span class="menu-help-icon-wrap">
    <app-centrui-icon [file]="'new/help-circle.svg'" [svgStyle]="{'fill': 'transparent'}"></app-centrui-icon>
    <svg
      *ngIf="showSurveyHelpNotification"
      class="help-survey-notification"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M5.92089 5.92089C8.15836 3.68342 9.2771 2.56468 10.5857 2.19562C11.5105 1.93479 12.4895 1.93479 13.4143 2.19562C14.7229 2.56468 15.8416 3.68342 18.0791 5.92089C20.3166 8.15836 21.4353 9.2771 21.8044 10.5857C22.0652 11.5105 22.0652 12.4895 21.8044 13.4143C21.4353 14.7229 20.3166 15.8416 18.0791 18.0791C15.8416 20.3166 14.7229 21.4353 13.4143 21.8044C12.4895 22.0652 11.5105 22.0652 10.5857 21.8044C9.2771 21.4353 8.15836 20.3166 5.92089 18.0791C3.68342 15.8416 2.56468 14.7229 2.19562 13.4143C1.93479 12.4895 1.93479 11.5105 2.19562 10.5857C2.56468 9.2771 3.68342 8.15836 5.92089 5.92089Z"></path>
      <path d="M12 8V12"></path>
      <path d="M12.125 15.75H12M12.25 15.75C12.25 15.8881 12.1381 16 12 16C11.8619 16 11.75 15.8881 11.75 15.75C11.75 15.6119 11.8619 15.5 12 15.5C12.1381 15.5 12.25 15.6119 12.25 15.75Z"></path>
    </svg>
  </span>
</button>

<div
  class="help-form"
  #helpForm
  *ngIf="helpFormVisible"
  [ngClass]="{'addin': addin, 'theme-lumi': isLumiTheme}"
>
  <div class="help-form-body">
    <div class="help-form-header" *ngIf="!hideHeader">
      <div class="help-form-header-start">
        <div class="return-title" *ngIf="step !== 'choice' && !skipChoiceStep">
          <div class="return-icon">
            <app-centrui-icon
              (click)="goBack()"
              [file]="'new/arrow-left-01.svg'"
              [svgStyle]="{'color': '#1E31BF'}"
            ></app-centrui-icon>
          </div>
          <span>{{ panelTitle }}</span>
        </div>
        <div class="help-form-title" *ngIf="step === 'choice' || skipChoiceStep" [@fadeInUp]="{ value: '', params: { delay: 0 } }">
          {{ panelTitle }}
        </div>
      </div>
      <button type="button" class="help-form-dismiss" (click)="dismiss()">
        <app-centrui-icon [file]="'new/cancel-01.svg'" style="width: 1rem; height: 1rem; opacity: 0.6;"></app-centrui-icon>
      </button>
    </div>

    <div class="help-form-content" [ngClass]="step">
      <ng-container *ngIf="step === 'choice'">
        <div class="help-buttons">
          <button
            type="button"
            class="help-option-item"
            [@fadeInUp]="{ value: '', params: { delay: 80 } }"
            (click)="showTours()"
          >
            <span>Show me...</span>
            <p>Learn how to use this page with a guided walkthrough.</p>
          </button>
          <button
            type="button"
            class="help-option-item"
            [@fadeInUp]="{ value: '', params: { delay: 170 } }"
            (click)="showSupport()"
          >
            <span>Submit a support request</span>
            <p>Describe your issue and our team will get back to you as soon as possible.</p>
          </button>
          <button
            type="button"
            class="help-option-item"
            *ngIf="activeCustomerSurvey"
            [@fadeInUp]="{ value: '', params: { delay: 260 } }"
            (click)="launchCustomerSurvey()"
          >
            <span>Take Survey</span>
            <p>Provide feedback of your experience in Polarix.</p>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="step === 'support' && !submitted">
        <form [formGroup]="freshDeskHelpForm" *ngIf="freshDeskHelpForm">
          <app-centrui-input
            [readOnly]="loading"
            [form]="freshDeskHelpForm"
            field="description"
            [inputName]="'description'"
            [inputType]="'textarea'"
            [inputPlaceHolder]="'Describe the problem you\'re facing…'"
          ></app-centrui-input>
        </form>
        <div class="help-form-buttons">
          <app-centrui-button
            [type]="'button'"
            [disabled]="loading"
            [size]="smallButtons ? 'small' : 'medium'"
            [style]="'secondary'"
            [text]="'Cancel'"
            (click)="dismiss()"
          ></app-centrui-button>
          <app-centrui-button
            [type]="'submit'"
            [disabled]="loading"
            [loading]="loading"
            [size]="smallButtons ? 'small' : 'medium'"
            [style]="'primary'"
            [text]="'Submit Help Request'"
            (click)="sendDataToFreshDesk()"
          ></app-centrui-button>
        </div>
      </ng-container>

      <ng-container *ngIf="step === 'tours'">
        <div class="help-tours-list" [class.scroll-locked]="toursScrollLocked">
          <p class="help-empty-message" *ngIf="tours.length === 0" [@fadeInUp]="{ value: '', params: { delay: 80 } }" (@fadeInUp.done)="onToursAnimationEnd()">
            No tours are available on this page.
          </p>
          <button
            type="button"
            class="help-option-item overview"
            *ngFor="let tour of overviewTours; let i = index"
            [@fadeInUp]="{ value: '', params: { delay: tourAnimationDelay(i) } }"
            (@fadeInUp.done)="onTourAnimationEnd(i)"
            (click)="launchTour(tour)"
          >
            <span>{{ tour.title }}</span>
            <p *ngIf="tour.description">{{ tour.description }}</p>
          </button>
          <div
            class="help-tours-divider"
            *ngIf="showTourDivider"
            [@fadeInUp]="{ value: '', params: { delay: tourAnimationDelay(overviewTours.length) } }"
            (@fadeInUp.done)="onTourAnimationEnd(overviewTours.length)"
          ></div>
          <div
            class="help-tours-search"
            *ngIf="showToursSearch"
            [@fadeInUp]="{ value: '', params: { delay: tourAnimationDelay(toursSearchIndex) } }"
            (@fadeInUp.done)="onTourAnimationEnd(toursSearchIndex)"
          >
            <app-centrui-icon file="ic-search.svg" class="help-tours-search-icon"></app-centrui-icon>
            <input
              type="text"
              class="help-tours-search-input"
              placeholder="Search tours..."
              [(ngModel)]="toursSearchQuery"
              (focus)="captureToursResultsMinHeight()"
              (input)="captureToursResultsMinHeight()"
            />
          </div>
          <div
            #regularToursResults
            class="help-tours-results"
            [style.min-height.px]="toursSearchQuery ? toursResultsMinHeight : null"
          >
            <p
              class="help-empty-message"
              *ngIf="showToursSearch && toursSearchQuery && filteredRegularTours.length === 0"
            >
              No tours match your search.
            </p>
            <button
              type="button"
              class="help-option-item"
              *ngFor="let tour of filteredRegularTours; let i = index"
              [@fadeInUp]="{ value: '', params: { delay: tourAnimationDelay(toursSearchIndex + (showToursSearch ? 1 : 0) + i) } }"
              (@fadeInUp.done)="onTourAnimationEnd(toursSearchIndex + (showToursSearch ? 1 : 0) + i)"
              (click)="launchTour(tour)"
            >
              <span>{{ tour.title }}</span>
              <p *ngIf="tour.description">{{ tour.description }}</p>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
